var fn = function( obj ){
var __t,__p='';
__p+='\n\n{\nc += texture2D(tDitherNoise, texCoordVP*uDitherTCScale.xy).xyz/255.0;\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;